// import { metricThresholds } from '../utils';

const setIndicatorColor = (value, type, currentMetricThresholds) => {
  if (type === 'disponibilidad') {
    if (!value || value === 0) return 'grey-primary';
    if (value > currentMetricThresholds[type].success) {
      return 'green-primary';
    }
    if (value >= currentMetricThresholds[type].warning) {
      return 'yellow-primary';
    }
    return 'red-primary';
  }

  if (!value || value === 0) return 'grey-primary';
  if (value <= currentMetricThresholds[type].success) {
    return 'green-primary';
  }
  if (value < currentMetricThresholds[type].warning) {
    return 'yellow-primary';
  }
  return 'red-primary';
};

export default setIndicatorColor;
